export default "__VITE_ASSET__BOgOSU3K__"